"use strict";

import * as THREE from "three";

const DouglasAsterHub: ShootPreset = {
    id: "DouglasAsterHub",
    shootCount: 1,

    maxWidth: .55,
    maxHeight: .55,

    lengthSegments: 4,
    widthSegments: 8,

    materialPreset: {
        shootTextureIndex: 17,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(0.96, 0.8, 0.04) },
            shootTextureColorB: { value: new THREE.Color(0.83, 0.51, 0) },
        },
    },

    pathFunction() {
        let points = [new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, .2, 0)];
        return new THREE.CatmullRomCurve3(points);
    },

    getNormalOffset(lengthProgress, widthProgress) {
        return Math.sin(widthProgress * Math.PI) * Math.sqrt(1 - Math.pow((1 - lengthProgress) - 1, 2));
    },

    getBinormalOffset(lengthProgress, widthProgress) {
        return Math.cos(widthProgress * Math.PI) * Math.sqrt(1 - Math.pow((1 - lengthProgress) - 1, 2));
    },

    transformInstance(i) {
        return new THREE.Matrix4();
    }
}

const DouglasAsterPetal: ShootPreset =
{
    id: "DouglasAsterPetal",
    shootCount: 21,

    maxWidth: .2,
    maxHeight: .1,

    lengthSegments: 08,
    widthSegments: 4,

    materialPreset: {
        shootTextureIndex: 7,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(0.58, 0.37, 0.91) },
            shootTextureColorB: { value: new THREE.Color(0.8, 0.74, 0.98) },

            // horizontalColorA: { value: new THREE.Color(1, 1, 1) },
            // horizontalColorB: { value: new THREE.Color(0.4, .6, .8) },
            // horizontalEdgeA: { value: .5 },
            // horizontalEdgeB: { value: .85 },
        },
    },

    pathFunction: () => {

        let points = [
            new THREE.Vector3(.5, 0, 0),
            new THREE.Vector3(2, .5, 0),
        ];

        let path = new THREE.CatmullRomCurve3(points);

        return path;
    },

    getBinormalOffset: (lengthProgress, widthProgress) => {
        let height = Math.sin((widthProgress / 2) * (Math.PI)) * widthProgress;
        height *= Math.sin((1 - lengthProgress) * Math.PI);

        return height;
    },

    getNormalOffset: (lengthProgress, widthProgress) => {
        if (lengthProgress < .5) {
            return Math.pow(lengthProgress + .5, 2) * widthProgress;
        } else {
            return (1 - Math.pow(lengthProgress, 12)) * widthProgress;
        }
    }
}

export const DouglasAster: BloomPreset = {
    bounds: 2,
    shootPresets: [DouglasAsterPetal, DouglasAsterHub]
}
